import { useCookieExistsWatcher } from "../../browser/useCookieWatcher";

export function useLoginStatus(): boolean {
   // const tokenXExists = useCookieExistsWatcher("token_x");
   // const tokenYExists = useCookieExistsWatcher("token_y");
  const sessionExists = useCookieExistsWatcher("session");

  return sessionExists;
}
